import { useMutation } from '@tanstack/react-query'

import { donationApi } from '@/src/features/donation/api/donationApi'
import type { DONATION_SOURCE } from '@/src/features/donation/api/types/donation'
import { useToast } from '@/src/general/components/ToastContext'
import { useTranslate } from '@/src/lang/useTranslate'

export const useDonateLaterReminderMutation = () => {
  const { addToast } = useToast()
  const { t } = useTranslate()

  return useMutation({
    mutationFn: (payload: { source?: DONATION_SOURCE; campaign?: string }) =>
      donationApi.setDonateLaterReminder(payload),
    retry: 0,
    onSuccess: () => {
      addToast({
        colors: 'success',
        message: t('app.donation.later.success.toast'),
      })
    },
  })
}
